import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAlertTriangleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_7339_61274)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.43.8c-.36.06-.59.12-.84.25q-.55.27-.88.74c-.18.25-7.64 13.06-7.73 13.26-.12.3-.17.55-.17.91 0 .18.01.39.03.47.22 1.05 1.05 1.84 2.07 1.98.14.02 1.23.02 3.56.02l3.36-.01.13-.06c.17-.08.35-.26.43-.43.05-.11.06-.17.06-.36 0-.2 0-.24-.07-.37-.08-.16-.26-.33-.41-.4l-.12-.06-3.38-.01-3.39-.01-.13-.07c-.37-.17-.54-.6-.38-.95l3.78-6.5c2.77-4.75 3.75-6.4 3.83-6.49q.18-.2.5-.19.3 0 .49.18c.07.07.95 1.57 3.15 5.32 2.07 3.57 3.08 5.27 3.16 5.36q.23.26.62.26c.25 0 .42-.07.6-.25q.25-.24.24-.6c0-.15 0-.2-.07-.34-.08-.16-6.05-10.4-6.18-10.6-.34-.5-.9-.87-1.49-1-.17-.04-.64-.06-.77-.04m.05 5q-.4.12-.58.5l-.07.14V8.9c0 1.9 0 2.47.03 2.55.07.23.3.47.54.55.13.05.4.05.54.01.22-.07.47-.31.56-.55.04-.11.06-4.67.02-4.93q-.08-.46-.5-.66c-.14-.06-.4-.09-.54-.05m.04 7.28q-.3.04-.56.23c-.7.51-.67 1.54.06 2.01.55.36 1.3.2 1.68-.36.5-.74.02-1.77-.87-1.87-.09-.01-.23-.02-.3 0m11.62.48q-.2.05-.34.17l-3.02 3.74c-1.6 2.02-2.93 3.67-2.94 3.68l-1.33-.97c-1.47-1.1-1.45-1.1-1.76-1.07q-.5.04-.72.49c-.07.13-.08.18-.08.32l.01.24c.03.13.12.3.21.39.07.07 3.08 2.33 3.34 2.5.25.18.57.2.85.06q.13-.07.22-.15l3.28-4.08c1.96-2.46 3.23-4.06 3.27-4.14.06-.12.06-.17.06-.35 0-.2 0-.24-.06-.36q-.14-.26-.4-.4c-.11-.07-.17-.08-.33-.09-.1 0-.22 0-.26.02"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7339_61274">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconAlertTriangleCheck;
